import { IconChartBar, IconCheck, IconFileCheck, IconPlaylistX, IconTrophy } from "@tabler/icons-react";
import { Container } from "modules/layout";
import Image from "next/image";
import Router, { useRouter } from "next/router";
import pages from "pages/_router";
import React from "react";
import { api } from "shared/api";
import { Button, YoutubeEmbed } from "shared/ui";
import { FinancesEducationLayout } from "./_layout";

import fpImage from "./images/fp.png";
import styles from "./index.page.module.scss";

const FinancesEducationPage = () => {
  const companySlug = useRouter().query.company as string;
  const educationRouter = pages.company(companySlug).finances.education;
  const settings = api.financeSettings.useFinanceSettingsGet(companySlug);

  const onNext = async () => {
    await api.financeSettings.financeSettingsUpdateEducationStep(companySlug, { educationStep: 1 });
    await settings.mutate();
    return Router.push(educationRouter.step("01").href);
  };

  const onSkip = async () => {
    await api.financeSettings.financeSettingsUpdateEducation(companySlug, { education: false });
    await settings.mutate();
    return Router.push(pages.company(companySlug).finances.href);
  };

  return (
    <FinancesEducationLayout>
      <div className={styles.index_page}>
        <Container className={styles.container}>
          <div className={styles.head}>
            <div className={styles.main}>
              <h1 className={styles.title}>Наведите порядок в финансах и сделайте бизнес более прибыльным</h1>
              <div className={styles.subtitle}>
                Создайте финансовую модель. Спланируйте бюджет на месяц. Внедрите систему заявок на расходы.
              </div>

              <Button className={styles.button} size="large" onClick={onNext}>
                Начать знакомство с модулем
              </Button>
            </div>

            <div className={styles.video}>
              <YoutubeEmbed embedId="NYTqvJxljo4" />
            </div>
          </div>
          <div className={styles.card_list}>
            <div className={styles.card}>
              <div className={styles.icon}>
                <IconFileCheck size={40} stroke={2} />
              </div>

              <div className={styles.title}>Порядок и&nbsp;контроль финансов</div>
              <div className={styles.description}>
                Собственник управляет цифрами в&nbsp;бизнесе. Перед глазами&nbsp;&mdash; простая и&nbsp;понятная
                отчетность движения денег.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.icon}>
                <IconPlaylistX size={40} stroke={2} />
              </div>

              <div className={styles.title}>Оптимизация расходов и&nbsp;долгов</div>
              <div className={styles.description}>
                Система фондов убирает лишние расходы и&nbsp;позволяет накопить денежные резервы.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.icon}>
                <IconTrophy size={40} stroke={2} />
              </div>

              <div className={styles.title}>Сотрудники бьются за&nbsp;доход</div>
              <div className={styles.description}>
                Система ЗП&nbsp;от&nbsp;результата поднимает ответственность топов за&nbsp;доходы и&nbsp;расходы
                компании.
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.icon}>
                <IconChartBar size={40} stroke={2} />
              </div>

              <div className={styles.title}>Больше денег собственнику</div>
              <div className={styles.description}>
                Владелец получает дивиденды. Его процент закладывается в&nbsp;финансовую модель и&nbsp;выплачивается
                еженедельно.
              </div>
            </div>
          </div>

          <div className={styles.large_card}>
            <div className={styles.main}>
              <h1 className={styles.title}>
                Научитесь эффективной системе управления финансами при помощи интерактивного урока.{" "}
              </h1>

              <div className={styles.list}>
                <div className={styles.list_item}>
                  <div className={styles.icon}>
                    <IconCheck size={20} stroke={1.5} />
                  </div>
                  <div className={styles.text}>Создадим финансовую модель вашего бизнеса</div>
                </div>
                <div className={styles.list_item}>
                  <div className={styles.icon}>
                    <IconCheck size={20} stroke={1.5} />
                  </div>
                  <div className={styles.text}>
                    Организуем контроль расходов при помощи системы фондов. Научимся заранее планировать траты и
                    накапливать на них средства
                  </div>
                </div>
                <div className={styles.list_item}>
                  <div className={styles.icon}>
                    <IconCheck size={20} stroke={1.5} />
                  </div>
                  <div className={styles.text}>
                    Поймем, как при помощи плана бюджета на месяц сделать так, чтобы компания работала в плюс
                  </div>
                </div>
                <div className={styles.list_item}>
                  <div className={styles.icon}>
                    <IconCheck size={20} stroke={1.5} />
                  </div>
                  <div className={styles.text}>Создадим бюджет вашей компании на месяц</div>
                </div>
                <div className={styles.list_item}>
                  <div className={styles.icon}>
                    <IconCheck size={20} stroke={1.5} />
                  </div>
                  <div className={styles.text}>Научимся добиваться выполнения плана</div>
                </div>
              </div>

              <div className={styles.actions}>
                <Button size="large" type="primary" onClick={onNext}>
                  Начать знакомство с модулем
                </Button>
                <Button size="large" type="secondary" onClick={onSkip}>
                  Пропустить обучение и перейти в Финансы
                </Button>
              </div>
            </div>

            <div className={styles.image}>
              <Image src={fpImage} alt="" />
            </div>
          </div>
        </Container>
      </div>
    </FinancesEducationLayout>
  );
};

export default FinancesEducationPage;
